import api from './api';

export type ListingKey =
  | 'personal'
  | 'business'
  | 'tasks'
  | 'letters'
  | 'dispatches'
  | 'quotations'
  | 'invoices'
  | 'task_templates'
  | 'staffs'
  | 'teams'
  | 'permissions'
  | 'task_types'
  | 'users'
  | 'agents'
  | 'customer_personal'
  | 'customer_tasks'
  | 'sub_tasks';

type ListingSettingsResponse = {
  success: boolean;
  data?: {
    listing_key: ListingKey;
    visible_columns: string[] | null;
    column_widths?: Record<string, number> | null;
    sort_key?: string | null;
    sort_order?: 'ascend' | 'descend' | null;
    column_filters?: Record<string, unknown> | null;
  };
};

export const listingSettingsService = {
  async getListingSettings(listingKey: ListingKey): Promise<{
    visible_columns: string[] | null;
    column_widths: Record<string, number> | null;
    sort_key: string | null;
    sort_order: 'ascend' | 'descend' | null;
    column_filters: Record<string, unknown> | null;
  } | null> {
    const response = await api.get<ListingSettingsResponse>(`/user-listing-settings/${listingKey}`);
    if (!response.data?.data) {
      return null;
    }
    return {
      visible_columns: response.data.data.visible_columns ?? null,
      column_widths: response.data.data.column_widths ?? null,
      sort_key: response.data.data.sort_key ?? null,
      sort_order: response.data.data.sort_order ?? null,
      column_filters: response.data.data.column_filters ?? null,
    };
  },
  async getVisibleColumns(listingKey: ListingKey): Promise<string[] | null> {
    const settings = await this.getListingSettings(listingKey);
    return settings?.visible_columns ?? null;
  },
  async updateVisibleColumns(listingKey: ListingKey, visibleColumns: string[]): Promise<void> {
    await this.updateListingSettings(listingKey, { visible_columns: visibleColumns });
  },
  async updateListingSettings(
    listingKey: ListingKey,
    payload: {
      visible_columns?: string[];
      column_widths?: Record<string, number>;
      sort_key?: string | null;
      sort_order?: 'ascend' | 'descend' | null;
      column_filters?: Record<string, unknown> | null;
    }
  ): Promise<void> {
    await api.put(`/user-listing-settings/${listingKey}`, payload);
  },
};
